import React, { useEffect, useState, useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import Typed from 'typed.js';
import '../styles/Question.css';

function Question({ question, options, selectedOptionIndex, setSelectedOptionIndex, handleAnswer }) {
  const [showOptions, setShowOptions] = useState(false);
  const [visibleOptions, setVisibleOptions] = useState([]);
  const typedRef = useRef(null);

  const handleOptionClick = (index) => {
    console.log(`Option clicked: ${index}`); // Debug statement
    setSelectedOptionIndex(index);
    handleAnswer(index); // Pass the index to handleAnswer
  };

  useHotkeys('Enter', (event) => {
    event.preventDefault();
    console.log(`Enter pressed, selected option: ${selectedOptionIndex}`); // Debug statement
    handleAnswer(selectedOptionIndex); // Use the selectedOptionIndex
  });

  // Answer directly with number keys 1-4
  useHotkeys('1,2,3,4', (event) => {
    event.preventDefault();
    const pressed = parseInt(event.key, 10);
    if (!Number.isNaN(pressed)) {
      const index = pressed - 1;
      if (index >= 0 && index < visibleOptions.length) {
        handleOptionClick(index);
      }
    }
  }, [visibleOptions, selectedOptionIndex]);

  useEffect(() => {
    if (typedRef.current) {
      typedRef.current.destroy();
    }

    typedRef.current = new Typed('.typing-question', {
      strings: [question],
      typeSpeed: 30,
      showCursor: false,
      onComplete: () => {
        setTimeout(() => {
          setShowOptions(true);
          options.forEach((option, index) => {
            setTimeout(() => {
              setVisibleOptions((prev) => [...prev, option]);
            }, index * 40);
          });
        }, 500);
      }
    });

    return () => {
      typedRef.current.destroy();
    };
  }, [question]);

  return (
    <div className="container">
      <h2 className="typing-question"></h2>
      <div className={`options ${showOptions ? '' : 'is-hidden'}`}>
        {visibleOptions.map((option, index) => (
          <button
            key={index}
            className={`button option ${index === selectedOptionIndex ? 'selected-option' : ''}`}
            onClick={() => handleOptionClick(index)}
          >
            {index + 1}. {option} {index === question.correct_answer ? '(Correct)' : ''}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Question;